export const PRODUCTS_ROUTES = {
  BASE: '/products',
  CREATE: '/products/create',
  IMPORT: '/products/import',
  UPDATE: '/products/:id/update',
  DETAIL: '/products/:id',
};
